import config from "../config";

const getCarsSummary = async () => {
  let url = `${config.backendUrl}/car-numbers/get-cars-summary`;
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem("token") || ""}`,
    },
  });
  const data = await res.json();
  return data;
};

export default getCarsSummary;
